import { clearSoftRefreshTimestamps } from '../hooks/useModuleData';
import { clearGlobalThrottleMap } from '../hooks/refreshThrottleMap';

/**
 * Clears module-level in-memory caches that live outside Redux.
 * Call explicitly alongside resetAllStores / business switch — RESET_STORE
 * alone does not touch these Maps.
 */
export const clearModuleCaches = () => {
  clearSoftRefreshTimestamps();
  clearGlobalThrottleMap();
};
